import { images, resort } from "@/data/resort";
import { useBooking } from "../booking-context";
import { ResortButton, ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";
import { SiteFeatureList } from "./SiteFeatureList";

const features = [
  "Asphalt parking pad",
  "20 / 30 / 50 amp hookups",
  "Water",
  "Sewer",
  "Complimentary WiFi",
  "Picnic table",
] as const;

export function AccessibleSites() {
  const { openBooking } = useBooking();

  return (
    <section
      id="accessible"
      aria-labelledby="accessible-heading"
      className="scroll-mt-16 bg-background py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="order-1 lg:col-span-5 lg:order-none" y={36}>
            <img
              src={images.siteAccessible}
              alt="Accessible asphalt RV site with smooth access at Auburn RV Resort"
              width={1200}
              height={1400}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>

          <div className="order-2 lg:col-span-7 lg:order-none lg:pl-4">
            <Reveal>
              <Eyebrow>Accessible Accommodations</Eyebrow>
            </Reveal>
            <h2 id="accessible-heading" className="display-lg mt-6 max-w-[18ch]">
              <MaskReveal>Comfortable, Convenient</MaskReveal>
              <MaskReveal delay={0.08}>&amp; Accessible</MaskReveal>
            </h2>

            <Reveal delay={0.1}>
              <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
                Accessible RV sites are available for guests who require them. These sites feature
                asphalt parking pads and are available for daily, weekly and monthly stays.
              </p>
            </Reveal>

            <Reveal delay={0.14}>
              <SiteFeatureList features={features} />
            </Reveal>

            <Reveal delay={0.18}>
              <p className="mt-8 max-w-xl text-sm leading-relaxed text-muted-foreground">
                If you have specific accessibility requirements, please contact the resort so the
                team can help identify the most appropriate available site.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortButton variant="gold" onClick={openBooking} className="w-full sm:w-auto">
                  Ask About Accessible Sites
                </ResortButton>
                <ResortLink variant="outline" href="/contact-us/" className="w-full sm:w-auto">
                  Contact the Resort
                </ResortLink>
              </div>
            </Reveal>

            <Reveal delay={0.24}>
              <p className="eyebrow mt-6 text-muted-foreground">
                Or call{" "}
                <a href={resort.phoneHref} className="link-underline text-foreground">
                  {resort.phone}
                </a>
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
